import { Box } from '@mui/material'
import React, { memo } from 'react'
import Linha11LME from './linha11'
import Linha12LME from './linha12'
import Linha13LME from './linha13'
import Linha14LME from './linha14'
import Linha15LME from './linha15'

const Linha1LME = memo(() => {

    return (
        <>
            <Box width={1}>
                <Linha11LME />
                <Linha12LME />
                <Linha13LME />
                <Linha14LME />
                <Linha15LME />
            </Box>
        </>
    )
})

export default Linha1LME